<template>
    <v-dialog v-if="accountStep" :value="open" @input="close" max-width="520px" scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card tile elevation="0">
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                <span>{{ $translate('Withdraw from purchase') }}</span>
                <v-spacer />
                <v-btn icon :aria-label="$translate('Close')" @click="close"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text v-if="accountStep == 'login'" class="pt-4">
                <identification title="Log in with the account you made the purchase with to withdraw from it." />
            </v-card-text>

            <v-card-text v-else class="text-center pt-8">
                <v-avatar size="64" color="orange lighten-5">
                    <v-icon large color="orange darken-2">mdi-account-alert-outline</v-icon>
                </v-avatar>
                <p class="mt-6 text--primary font-weight-medium">{{ $translate('The purchase was made with another account. Log out and log in with the account you made the purchase with.') }}</p>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer />
                <v-btn text color="primary" :class="{ 'mr-n2': accountStep == 'login' }" @click="close">{{ $translate('Cancel') }}</v-btn>
                <v-btn v-if="accountStep == 'other_account'" color="primary" @click="logout">{{ $translate('Log out') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <withdrawal-dialog v-else-if="page" :value="open" @input="close"
        :lines="page.lines" :facility-name="page.facility"
        :person="page.person" :submit="submit" :link-state="page.status" :expired-date="page.deadline" />
</template>

<script>
import Identification from './Identification.vue';
import WithdrawalDialog from './WithdrawalDialog.vue';

export default {
    name: 'zoezi-withdrawal-link-dialog',

    components: { Identification, WithdrawalDialog },

    data: () => ({
        page: null,
        open: true,
    }),

    computed: {
        token() {
            return this.$route.query.withdraw;
        },
        userId() {
            return this.$store.state.isLoggedIn ? this.$store.state.user.id : null;
        },
        accountStep() {
            if (this.$store.state.isCheckingIfLoggedIn) {
                return null;
            }
            if (!this.userId) {
                return 'login';
            }

            return this.page?.status == 'other_account' ? 'other_account' : null;
        },
    },

    watch: {
        // Only the buyer sees the purchase, so the link is loaded again for each account that logs in.
        userId: {
            immediate: true,
            handler() {
                this.load();
            },
        },
        token() {
            this.load();
        },
    },

    methods: {
        async load() {
            this.page = null;
            if (!this.token || !this.userId) {
                return;
            }
            try {
                this.page = await this.$api.get('/api/memberapi/withdrawal/link/get', { token: this.token });
            } catch (error) {
                this.page = { status: 'invalid', facility: this.$store.state.settings.name };
            }
        },
        submit(paymentId, message) {
            return this.$api.post('/api/memberapi/withdrawal/add', { payment_id: paymentId, message, source: 'link' });
        },
        logout() {
            this.$store.dispatch('logout');
        },
        close() {
            this.open = false;
            this.$router.replace({ query: { ...this.$route.query, withdraw: undefined } });
        },
    },
};
</script>
